import { ArticleContainer } from '@components/core/container/Container';
import ArticleStyle from '@styles/ArticleStyle';
import parse from 'html-react-parser';
import AuthorCard from './authorCard/AuthorCard';
import { useACF } from '@context/ACFContext';
import { PostTemplate } from 'types/globalTypes';
import ArticleProductCard from './articleProductCard/ArticleProductCard';
import ArticleTopBlock from './articleTopBlock/ArticleTopBlock';
import ArticleSideBar from './articleSideBar/ArticleSideBar';
import { useIsMobile } from '@hooks/useIsMobile';

const Article: React.FC = () => {
	const { postTemplate } = useACF() as { postTemplate?: PostTemplate };
	const article = postTemplate?.review_page_v4_article_settings;
	const isMobile = useIsMobile(1032);

	const {
		show_author_component,
		article_author_image,
		author_rating_image,
		tr_written_by_label,
		tr_author_biogrpahy,
		author_name,
	} = article?.author_component_settings || {};

	const {
		tr_article_title,

		article_limited_offer,
		tr_article_written_by_label,
		tr_article_meta_text,
		articles_date_days_ago,
	} = article?.article_meta_settings || {};

	const { show_article_product_card, tr_article_card_heading, tr_article_card_paragraph, article_card_cta } =
		article?.article_product_card_settings || {};

	return (
		<ArticleContainer>
			<ArticleStyle />
			<div style={{ maxWidth: isMobile ? '100%' : '670px' }}>
				<ArticleTopBlock
					title={tr_article_title || ''}
					offerLabel={article_limited_offer || ''}
					writtenLabel={tr_article_written_by_label || ''}
					metaText={tr_article_meta_text || ''}
					authorImage={article_author_image}
					authorName={author_name}
					daysAgo={articles_date_days_ago}
				/>
				<div className="post-content" id="product-info">
					{parse(window.postContent || '')}
				</div>
				{show_article_product_card && (
					<ArticleProductCard
						title={tr_article_card_heading || ''}
						paragraph={tr_article_card_paragraph || ''}
						cardLink={article_card_cta || {}}
					/>
				)}
				{show_author_component && (
					<AuthorCard
						author={author_name}
						writtenBy={tr_written_by_label}
						authorImage={article_author_image}
						rating={author_rating_image}
						aboutAuthor={tr_author_biogrpahy}
					/>
				)}
			</div>
			<ArticleSideBar />
		</ArticleContainer>
	);
};

export default Article;
